// tslint:disable-next-line: no-any
(window as any).__zone_symbol__BLACK_LISTED_EVENTS = ['mousemove'];
